import { create } from 'zustand';
import { ReactNode } from 'react';
import type { PolicyStore } from '../../../../widgets/Policy/model/types/PolicyStore';

import { PolicyRegistrationType } from '@/features/PolicyRegistration/model/schema/zodSchema';
import { CoastCalculationType } from '@/features/CoastCalculation/model/schema';

export const usePolicyStore = create<PolicyStore>((set) => ({
    authType: '',
    id: undefined,
    calculated: false,
    smsCode: '',
    smsError: '',
    price: '',
    ids: {
        pasportId: null,
        userId: null,
        creditInfoId: null,
        actualAddressId: null,
        postAddressId: null,
    },
    formData: {} as CoastCalculationType,
    secondFormData: {} as PolicyRegistrationType,
    policyProcess: 'CoastCalculation',
    isSuccess: false,
    error: '',
    isSmsModalOpen: false,
    isSendSmsError: false,
    accessDeniedMessage: '',
    esiaModalMessage: '',
    recalculationModalMessage: '',
    isLoading: false,
    isToolbarInBottomPosition: false,
    isDiscountActive: false,
    ipotekalifeRedirectUrl: '',
    isEmailFormSent: false,
    setIpotekalifeRedirectUrl: (ipotekalifeRedirectUrl: string) =>
        set(() => ({
            ipotekalifeRedirectUrl,
        })),
    setIsDiscountActive: (isDiscountActive: boolean) =>
        set(() => ({
            isDiscountActive,
        })),
    setAuthType: (authType: 'esia' | 'sberId') =>
        set(() => ({
            authType,
        })),
    setIsLoading: (isLoading: boolean) =>
        set(() => ({
            isLoading,
        })),
    setForm: (data: CoastCalculationType) =>
        set(() => ({
            formData: { ...data },
        })),
    setSecondForm: (data: Partial<PolicyRegistrationType>) =>
        set(() => ({
            secondFormData: { ...data },
        })),
    setPolicyProcess: (value) =>
        set(() => ({
            policyProcess: value,
        })),
    setCalculated: (value) =>
        set(() => ({
            calculated: value,
        })),
    setPrice: (value) =>
        set(() => ({
            price: value,
        })),
    setId: (id) =>
        set(() => ({
            id,
        })),
    setIsSuccess: (isSuccess) =>
        set(() => ({
            isSuccess,
        })),
    setSmsCode: (smsCode) =>
        set(() => ({
            smsCode,
        })),

    setIds: (ids) =>
        set(() => ({
            ids,
        })),

    setError: (error) => {
        set(() => ({
            error,
        }));
    },
    setAccessDeniedMessage: (accessDeniedMessage) => {
        set(() => ({
            accessDeniedMessage,
        }));
    },
    setEsiaModalMessage(esiaModalMessage) {
        set(() => ({
            esiaModalMessage,
        }));
    },
    setRecalculationModalMessage: (recalculationModalMessage: string | ReactNode) =>
        set(() => ({
            recalculationModalMessage,
        })),
    setIsSmsModalOpen: (isSmsModalOpen: boolean) =>
        set(() => ({
            isSmsModalOpen,
        })),
    setSmsError: (smsError) => {
        set(() => ({
            smsError,
        }));
    },
    setIsSendSmsError: (isSendSmsError) => {
        set(() => ({
            isSendSmsError,
        }));
    },
    setIsToolbarInBottomPosition: (isToolbarInBottomPosition) => {
        set(() => ({
            isToolbarInBottomPosition,
        }));
    },
    setIsEmailFormSent: (isEmailFormSent) => {
        set(() => ({
            isEmailFormSent,
        }));
    },
    cleanUpPolicyStore: () => {
        set(() => ({
            id: undefined,
            calculated: false,
            smsCode: '',
            smsError: '',
            price: '',
            ids: {
                pasportId: null,
                userId: null,
                creditInfoId: null,
                actualAddressId: null,
                postAddressId: null,
            },
            formData: {} as CoastCalculationType,
            secondFormData: {} as PolicyRegistrationType,
            policyProcess: 'CoastCalculation',
            isSuccess: false,
            error: '',
            isSendSmsError: false,
            accessDeniedMessage: '',
            IsToolbarInBottomPosition: false,
        }));
    },
}));
